var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewAltLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3.5,
    stroke: "#211A1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 12 20 4 12 4C4 4 3 12 3 12",
    stroke: "#211A1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAltLight);
export default __webpack_public_path__ + "static/media/View_alt_light.42cf846f078269d0fd382a1ce2f1efc6.svg";
export { ForwardRef as ReactComponent };